import React, { useEffect, useState } from "react";
import "./FirstWidgetScreen.scss";
import { useSelector } from "react-redux";
import { BsChevronRight, BsChevronDown } from "react-icons/bs";
import { AiOutlineUser, AiOutlineClockCircle } from "react-icons/ai";
import LogoWhite from "../../../assets/LogoWhite.png";
import ReviewsAverage from "../../../components/ReviewsAverage/ReviewsAverage";
import { CgClose } from "react-icons/cg";
import { locale } from "../../../translate/sweden";

let intervalScroll = null;
let timeoutClear = null;

const FirstWidgetScreen = (props) => {
  const [expandReviews, setExpandReviews] = useState(false);

  const widgetInfo = useSelector((state) => state.widget.widget);

  const handleExpand = () => {
    if (expandReviews) {
      setExpandReviews(false);
    } else {
      setExpandReviews(true);
      const wrapper = document.querySelector(".booking");
      intervalScroll = setInterval(
        () => wrapper.scroll(0, wrapper.scrollTop + 10),
        10
      );
      timeoutClear = setTimeout(() => clearInterval(intervalScroll), 500);
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalScroll);
      clearTimeout(timeoutClear);
    };
  }, []);

  return (
    <div className="booking">
      <div className="close" onClick={props.onClose}>
        <CgClose />
      </div>
      <div
        className="preview"
        style={{
          backgroundImage: `${
            widgetInfo.company.widget_settings.background_color
              ? widgetInfo.company.widget_settings.background_color
              : "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)"
          }`,
        }}
      >
        <img
          src={
            props.widgetInfo.company.widget_settings.logo
              ? props.widgetInfo.company.widget_settings.logo
              : LogoWhite
          }
          alt="Company Logo"
        />
        <h1>Hej!</h1>
        <h3>{locale.startPage.headText}</h3>
      </div>
      <div className="personellPreview">
        <h2>{locale.startPage.startBooking}</h2>
        <div className="personell">
          <div className="singlePersonell abs">
            <AiOutlineUser />
          </div>
          <div className="singlePersonell">
            <AiOutlineUser />
          </div>
          <div>
            <p>{locale.startPage.nextFreeTime}</p>
            <div className="hours">
              <AiOutlineClockCircle
                style={{
                  color: widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8",
                }}
              />
              <span>10:30, ons 24 feb.</span>
            </div>
          </div>
        </div>
        <button
          style={{
            backgroundColor: widgetInfo.company.widget_settings.main_color
              ? widgetInfo.company.widget_settings.main_color
              : "#1A73E8",
          }}
          onClick={props.nextStep}
        >
          {locale.startPage.bookAnAppointment} <BsChevronRight />
        </button>
      </div>
      <div
        className={"expand" + (expandReviews ? " active" : "")}
        onClick={handleExpand}
      >
        <div className="open-avg-reviews">
          <h1>{locale.startPage.whatOurCustomersSay}</h1>
          <BsChevronDown />
        </div>
        <ReviewsAverage
          rating={widgetInfo.company.average_rating}
          reviewsLen={widgetInfo.company.reviews.length}
          grades={widgetInfo.company.rating_grades}
        />
        <div
          className="see-all-reviews"
          style={{
            color: widgetInfo.company.widget_settings.main_color
              ? widgetInfo.company.widget_settings.main_color
              : "#1A73E8",
          }}
          onClick={props.openReviews}
        >
          {locale.startPage.seeAllRecensions}
        </div>
      </div>
    </div>
  );
};

export default FirstWidgetScreen;
